import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_v_file_input_form = _resolveComponent("v-file-input-form");
  var _component_ValidationProvider = _resolveComponent("ValidationProvider");
  return _openBlock(), _createBlock(_component_ValidationProvider, {
    rules: $props.rules,
    name: $options.nameInternal,
    "model-value": $data.valueInternal,
    ref: "provider"
  }, {
    default: _withCtx(function (_ref) {
      var errors = _ref.errors,
        errorMessage = _ref.errorMessage,
        field = _ref.field;
      return [_createVNode(_component_v_file_input_form, {
        value: $data.valueInternal,
        "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
          return $data.valueInternal = $event;
        }),
        inputId: $props.inputId,
        inputDataCy: $props.dataCy,
        label: $props.label,
        description: $props.description,
        accept: $props.accept,
        errors: errors,
        required: $options.requiredRule
      }, null, 8 /* PROPS */, ["value", "inputId", "inputDataCy", "label", "description", "accept", "errors", "required"])];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["rules", "name", "model-value"]);
}